'use client'
import { Button, Spinner } from '@nextui-org/react'
import React from 'react'

export default function ButtonWSpinner(props) {
  const {
    type, 
    className, 
    color="secondary", 
    label, 
    isLoading, 
    spinnerColor="white",
    variant="solid",
    onClick=() => {},
    disabled=false
  } = props
  return (
    <>
      <Button disabled={disabled} variant={variant} onClick={onClick} type={type} className={className} color={color} auto>
        {isLoading ? <Spinner size='sm' color={spinnerColor} /> : label}
      </Button>
    </>
  )
}
